import { Box } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

type TSettingBlockItem = {
  title: string;
  children?: React.ReactNode;
};

export const SettingBlockItem = ({ title, children }: TSettingBlockItem) => {
  return (
    <Box>
      <CustomTypography variant="subtitle1" fontWeight={700} mb={1}>
        {title}
      </CustomTypography>
      <div style={{ display: 'flex', gap: 8 }}>{children}</div>
    </Box>
  );
};
